module.exports = __webpack_public_path__ + "static/media/IDCards.3a7d98ba.svg";